import { createRouter, createWebHistory } from 'vue-router'
import LandingPage from '@/components/LandingPage.vue'
import MovieGallery from '@/components/MovieGallery.vue'
import HairGallery from "@/components/HairGallery.vue";
import MakeupGallery from "@/components/MakeupGallery.vue";
import SFXGallery from "@/components/SFXGallery.vue";
import BehindScenesGallery from "@/components/BehindScenesGallery.vue";
import CVPage from "@/components/CVPage.vue";
import AdminPanel from "@/components/AdminPanel.vue";
import AdminDashboard from "@/components/AdminDashboard.vue";
import ContactPage from "@/components/ContactPage.vue";

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            path: '/',
            name: 'home',
            component: LandingPage
        },
        {
            path: '/makeup',
            name: 'MakeupGallery',
            component: MakeupGallery,
        },
        {
            path: '/hair',
            name: 'HairGallery',
            component: HairGallery,
        },
        {
            path: '/sfx',
            name: 'SFXGallery',
            component: SFXGallery,
        },
        {
            path: '/behind-scenes',
            name: 'BehindScenesGallery',
            component: BehindScenesGallery,
        },
        {
            path: '/admin',
            name: 'AdminPanel',
            component: AdminPanel,
        },
        {
            path: '/admindashboard',
            name: 'AdminDashboard',
            component: AdminDashboard,
            beforeEnter: (to, from, next) => {
                const token = localStorage.getItem('token');
                if (token) {
                    next();
                } else {
                    next('/admin');
                }
            },
        },
        {
            path: '/cv',
            name: 'CV',
            component: CVPage,
        },
        {
            path: '/movies',
            name: 'movies',
            component: MovieGallery
        },
        {
            path: '/contact',
            name: 'contact',
            component: ContactPage
        }
    ]
});

export default router;